import React, { useEffect, useState } from "react";
import { Link, Location } from "react-router-dom";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const   EquipmentTitleNavigator: any = () => {
  const location = useLocation();
  const { t } = useTranslation(["operation"]);

  return (
    <>
      <Box
        component={"div"}
        className="navigationBoxClass equipment"
        sx={{ padding: "0 16px" }}
      >
        <Tabs
          sx={{
            boxShadow: "0px -4px 0px rgba(151, 151, 151, 0.2) inset",
          }}
          TabIndicatorProps={{
            sx: {
              height: "5px",
              backgroundColor: "rgba(200, 1, 125, 1)",
            },
          }}
          value={location.pathname}
          aria-label="Equipment tabs"
        >
          <Tab
            to={"/operation/vehicles/equipments/list"}
            component={Link}
            label={
              <Box>
                <Typography className="transportatorCapitalize">
                  {t("vehicleEquipment.pageTitles.equipmentTab")}
                </Typography>
              </Box>
            }
            value={"/operation/vehicles/equipments/list"}
          ></Tab>
          <Tab
            to={"/operation/vehicles/equipments/list/kit"}
            component={Link}
            label={
              <div>
                <Typography className="transportatorCapitalize">
                  {t("vehicleEquipment.pageTitles.equipmentKitTab")}
                </Typography>
              </div>
            }
            value={"/operation/vehicles/equipments/list/kit"}
          ></Tab>
        </Tabs>
      </Box>
    </>
  );
};
export default EquipmentTitleNavigator;
